import { render } from "./SimpleIntegerCard.vue?vue&type=template&id=456af706&scoped=true"
import script from "./SimpleIntegerCard.vue?vue&type=script&lang=js"
export * from "./SimpleIntegerCard.vue?vue&type=script&lang=js"

import "./SimpleIntegerCard.vue?vue&type=style&index=0&id=456af706&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-456af706"]])

export default __exports__